export const state = () => ({
  showBrowserValidModal: false
});
export const mutations = {
  setBrowserValidModal (state, show) {
    state.showBrowserValidModal = show;
  }
};
